<div class="wizzard-error" *ngIf="(errors$ | async)?.length > 0">
    <div class="wizzard-error__inner">
        <ng-container *ngFor="let error of errors$ | async;trackBy: trackBy">


            <div class="wizzard-error__item -error">
                <div class="wizzard-error__item-bd">
                    <shared-indicator class="wizzard-error__item-icon" size="xs" [inverted]="true" feel="negative">!
                    </shared-indicator>
                    <div class="wizzard-error__item-label">
                        {{error}}
                    </div>
                </div>
            </div>


        </ng-container>
    </div>
</div>